module.exports = __webpack_public_path__ + "static/media/panormaWordmark.13488dd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/panormaWordmark.svg
// module id = 430
// module chunks = 0